import { component } from 'picoapp';
import noUiSlider, { target as TargetElement } from 'nouislider';
import Drawer from 'utils/drawer';
import { updateQuery, resetFilter } from 'utils/filter';

export default component((node: HTMLFormElement) => {
  const reset: HTMLInputElement = node.querySelector('[data-reset]');

  const drawer = Drawer(node);

  document.addEventListener('filter:toggle', () => {
    drawer.open();
  });

  node.addEventListener('change', () => {
    updateQuery(node);
  });

  reset.addEventListener('click', () => {
    resetFilter(node);
  });

  // Price slider
  const lowValue: HTMLInputElement = node.querySelector('[data-value-low]');
  const highValue: HTMLInputElement = node.querySelector('[data-value-high]');

  const price: TargetElement = node.querySelector('[data-price]');
  const minValue = Number(price.dataset.min);
  const maxValue = Number(price.dataset.max);

  noUiSlider.create(price, {
    start: [lowValue.value, highValue.value],
    step: 1,
    range: {
      min: minValue,
      max: maxValue,
    },
    format: {
      to(value) {
        return value.toFixed();
      },
      from(value) {
        return Math.round(Number(value));
      },
    },
  });

  const updateValue = (input: HTMLInputElement, val: string) => {
    input.value = val;
    input.setAttribute('value', val);
  };

  price.noUiSlider.on('update', (values) => {
    const [min, max] = values;
    updateValue(lowValue, `${min}`);
    updateValue(highValue, `${max}`);
  });

  price.noUiSlider.on('set', () => {
    updateQuery(node);
  });

  document.addEventListener('filter:reset', () => {
    price.noUiSlider.set(['0', highValue.max]);
  });
});
